module.exports = __webpack_public_path__ + "static/img/4.68a47a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/changeBg/4.png
// module id = w2vh
// module chunks = 0